const debounce = require('debounce');
const { Select } = require('../modules/select');

class ArchiveFilters {
    constructor() {
        const form = document.querySelector('.archive-filters');

        if (form) {
            this.init(form);
        }
    }

    init(form) {
        this.form = form;
        this.baseLink = this.form.getAttribute('data-base-link') ?? null;
        this.loaders = [
            this.form.nextElementSibling,
            this.form.querySelector('.loader'),
        ];
        this.listWrapper = document.querySelector('.js-archive-list');
        this.filterItems = this.form.querySelectorAll(
            '.archive-filters__filter-item'
        );
        this.mobileTriggerButton = this.form.querySelector(
            '.archive-filters__mobile-filters-button'
        );
        this.closeMobileFiltersElements = this.form.querySelectorAll(
            '.js-close-mobile-filters'
        );
        this.filtersElementsWrapper = this.form.querySelector(
            '.archive-filters__left'
        );
        this.filterCountElements =
            this.form.querySelectorAll('.js-filter-count');
        this.perPageSelect = this.form.querySelector('.form-select.-per_page');
        this.pageInput = this.form.querySelector("[name='pg']");
        this.allResultsInput = this.form.querySelector("[name='all_results']");
        this.blockedParams = [
            'action',
            'all_results',
            'taxonomy',
            'term_ids',
            '_range_min',
            '_range_max',
            'base_link',
        ];

        this.debounceFilter = debounce(this.onFormSubmit.bind(this), 500);

        this.handleEvents();
    }

    handleEvents() {
        if (this.filterItems.length) {
            this.boundWindowClick = this.onWindowClick.bind(this);
            window.addEventListener('click', this.boundWindowClick);

            this.filterItems.forEach(filterItem => {
                const button = filterItem.querySelector(
                    '.archive-filters__filter-name-wrapper'
                );
                const body = filterItem.querySelector(
                    '.archive-filters__filter-body'
                );

                button.addEventListener(
                    'click',
                    this.onFilterItemButtonClick.bind(this)
                );
            });
        }

        if (this.perPageSelect) {
            this.perPageSelect.addEventListener('onSelectChange', e => {
                this.pageInput.value = 1;
                this.debounceFilter(e);
            });
        }

        this.form.addEventListener('submit', e => {
            e.preventDefault();
        });

        this.form.addEventListener('input', e => {
            this.pageInput.value = 1;
            this.allResultsInput.value = '';
            this.debounceFilter(e);
        });

        if (this.mobileTriggerButton) {
            this.mobileTriggerButton.addEventListener(
                'click',
                this.onMobileTriggerButtonClick.bind(this)
            );
        }

        if (this.closeMobileFiltersElements.length) {
            this.closeMobileFiltersElements.forEach(element => {
                element.addEventListener(
                    'click',
                    this.onCloseFiltersElementClick.bind(this)
                );
            });
        }
    }

    onWindowClick(e) {
        const paginationLink = e.target.closest('[data-pagination-link]');
        if (paginationLink && this.form && this.pageInput) {
            e.preventDefault();
            this.pageInput.value = this.getPageFromPaginationLink(
                paginationLink
            );
            this.debounceFilter(e);
            return;
        }

        if (!e.target.closest('.archive-filters__filter-item')) {
            this.filterItems.forEach(filterItem => {
                if (filterItem.classList.contains('-expanded')) {
                    filterItem.classList.remove('-expanded');
                }
            });
        }

        if (e.target.getAttribute('data-pagination-page')) {
            this.pageInput.value = e.target.getAttribute(
                'data-pagination-page'
            );
            this.debounceFilter(e);
        }
    }

    getPageFromPaginationLink(link) {
        if (!link || !link.href) {
            return 1;
        }

        try {
            const url = new URL(link.href, window.location.origin);
            const match = url.pathname.match(/\/strona\/(\d+)\/?$/);
            if (match && match[1]) {
                return parseInt(match[1], 10);
            }
        } catch (error) {
            return 1;
        }

        return 1;
    }

    onFilterItemButtonClick(e) {
        const parent = e.target.parentElement;
        if (parent.classList.contains('-expanded')) {
            parent.classList.remove('-expanded');
        } else {
            if (window.innerWidth > 991.98) {
                this.filterItems.forEach(element => {
                    element.classList.remove('-expanded');
                });
            }
            parent.classList.add('-expanded');
        }
    }

    async onFormSubmit(e) {
        e.preventDefault();
        try {
            this.submitStart();
            const formData = new FormData(this.form);
            formData.append('nonce', ajax.nonce);

            const req = await fetch(ajax.url, {
                method: 'POST',
                body: formData,
            });

            const data = await req.json();

            const { details, html, filters_html } = data.data;

            if (details.all_results) {
                this.allResultsInput.value = details.all_results.toString();
                if (this.filterCountElements.length) {
                    this.filterCountElements.forEach(element => {
                        element.textContent = details.all_results.length;
                    });
                }
            }

            if (html) {
                this.listWrapper.innerHTML = html;

                const elementPosition =
                    this.listWrapper.getBoundingClientRect().top +
                    window.pageYOffset;
                const offsetPosition = elementPosition - 250;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            }

            this.createURL();
            if (filters_html) {
                const currentForm = document.querySelector('.archive-filters');
                if (currentForm) {
                    currentForm.outerHTML = filters_html;
                    const reloadedForm = document.querySelector('.archive-filters');
                    if (reloadedForm) {
                        const selects = reloadedForm.querySelectorAll(
                            '.form-select:not(.initialized)'
                        );
                        if (selects.length) {
                            selects.forEach(select => {
                                new Select(select);
                            });
                        }
                    }
                    if (typeof window.initFormRange === 'function') {
                        window.initFormRange();
                    }
                    this.destroy();
                    new ArchiveFilters();
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            this.submitEnd();
        }
    }

    submitStart() {
        if (this.loaders.length) {
            this.loaders.forEach(loader => {
                loader.classList.add('-active');
            });
        }
    }

    submitEnd() {
        if (this.loaders.length) {
            this.loaders.forEach(loader => {
                loader.classList.remove('-active');
            });
        }
    }

    createURL() {
        const data = new FormData(this.form);
        const currentUrl = new URL(window.location.href);

        const baseUrl = this.baseLink
            ? this.baseLink
            : `${currentUrl.origin}${currentUrl.pathname}`;

        const params = new URLSearchParams();

        for (const [key, value] of data.entries()) {
            if (value.length && !this.blockedParams.includes(key)) {
                if (key === 'pg' && value == 1) continue;
                if (key === 'price_from' && value == 0) continue;
                if (key === 'per_page' && value == 12) continue;
                if (key === 'current_cat') continue;
                params.append(key, value);
            }
        }

        const paramsRaw = params.toString().replaceAll('%5B%5D', '[]');
        const paramsString = `${paramsRaw ? '?' : ''}${paramsRaw}`;

        const pagintionElements = document.querySelectorAll(
            '[data-pagination-link]'
        );
        if (pagintionElements.length) {
            pagintionElements.forEach(element => {
                if (!element.href || element.getAttribute('href') === '#') {
                    return;
                }

                const url = new URL(element.href, window.location.origin);
                url.search = paramsRaw;
                element.href = url.toString();
            });
        }

        const finalUrl = `${baseUrl}${paramsString}`;

        window.history.pushState({}, '', finalUrl);
    }

    destroy() {
        if (this.boundWindowClick) {
            window.removeEventListener('click', this.boundWindowClick);
        }
    }

    onMobileTriggerButtonClick() {
        if (!this.filtersElementsWrapper) return;

        this.filtersElementsWrapper.classList.add('-active');
    }

    onCloseFiltersElementClick() {
        if (!this.filtersElementsWrapper) return;

        this.filtersElementsWrapper.classList.remove('-active');
    }
}

new ArchiveFilters();
